<script setup lang="ts">
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { PropertiesInterface } from '~/types';
import PencilIcon from '@/img/icons/pencil.svg?component';
import DashboardIcon from '@/img/icons/dashboard.svg?component';

const currentUser = computed(() => usePage<PropertiesInterface>().props.current_user);
const currentResource = computed(() => usePage<PropertiesInterface>().props.current_resource);
</script>

<template>
  <section v-if="currentUser" class="adminbar">
    <div class="adminbar__wrapper">
      <ul class="adminbar__root-default">
        <li class="item">
          <a href="/cms-wmt/">
            <DashboardIcon />
            Dashboard
          </a>
        </li>

        <li v-if="currentResource" class="item">
          <a :href="currentResource.url" target="_blank" rel="nofollow">
            <PencilIcon />
            Edit {{ currentResource.name }}
          </a>
        </li>
      </ul>
      <ul class="adminbar__top-secondary">
        <li class="item item--account">
          <a href="/cms-wmt/"> Welcome, {{ currentUser.name }} </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.adminbar {
  @apply sticky bottom-0 z-[9999] w-full bg-accent px-4 py-3 text-white;

  &__wrapper {
    @apply flex items-center justify-between px-2.5;
  }

  &__root-default {
    @apply flex items-center gap-6;
  }

  a {
    @apply flex gap-2 items-center duration-300 hover:underline;
  }

  svg {
    @apply fill-white w-5 h-5 duration-300;
  }
}
</style>
